import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseButtonSize } from '../button/base-button.component';
import { ProfileDocumentResponse, DocumentListItemResponse } from '../../../../api';
import { BaseMimeType } from '../../enums/base-available-file-type.enum';

@Component({
  selector: 'base-document-info',
  templateUrl: './base-document-info.component.html',
})
export class BaseDocumentInfoComponent implements OnInit {
  @Output() viewDocumentClicked = new EventEmitter<boolean>();
  @Output() deleteClicked = new EventEmitter();
  @Input() documentControl:
    | FormControl<DocumentListItemResponse | File | null>
    | FormControl<ProfileDocumentResponse | File | null>;
  @Input() errorMessage: string;
  @Input() value: any;
  buttonSize = BaseButtonSize;
  baseMimeType = BaseMimeType;

  ngOnInit() {
    if (this.documentControl) {
      this.value = this.documentControl.value;
    }
  }
}
